import {
  IconSignal,
  IconFlash,
  IconInfoCircle,
  IconLeaf,
  IconVideo,
  IconNetwork,
  IconReports,
} from './icons';
import { ApiEmbeddedUrlIcon } from '@allbin/viu-types';
import React from 'react';

export const EmbedIcon: React.FC<{ icon: ApiEmbeddedUrlIcon }> = ({ icon }) => {
  switch (icon) {
    case 'info':
      return <IconInfoCircle />;
    case 'energy':
      return <IconFlash />;
    case 'video':
      return <IconVideo />;
    case 'stats':
      return <IconReports />;
    case 'eco':
      return <IconLeaf />;
    case 'signal':
      return <IconSignal />;
    case 'network':
      return <IconNetwork />;
    default:
      return <IconInfoCircle />;
  }
};
